import { createSlice } from '@reduxjs/toolkit';
import { IDashboardData } from '../constants/interface';

const initialState: IDashboardData = {
  cycleOptions: [],
  ptpOverview: {
    totalUnpaidCases: 0,
    totalUnpaidEmiAmount: 0,
    brokenPtp: {
      count: 0,
      amount: 0
    },
    todayPtp: {
      count: 0,
      amount: 0
    },
    futurePtp: {
      count: 0,
      amount: 0
    },
    noPtp: {
      count: 0,
      amount: 0
    }
  },
  emiCollectedOverview: {
    totalEmiAllocated: 0,
    emiCollected: 0,
    cycleEmiTarget: 0,
    todayEmiCollected: 0,
    todayEmiTarget: 0,
    lastAllocationLevel: 0,
    allocatedCasesCount: 0,
    daysRemainingInAllocation: 0
  },
  callData: {
    callBackRequestsData: {
      notAttempted: 0,
      notConnected: 0,
      connected: 0
    },
    callCoverageData: {
      today: {
        notAttempted: 0,
        notConnected: 0,
        connected: 0
      },
      cycle: {
        notAttempted: 0,
        notConnected: 0,
        connected: 0
      }
    },
    totalCallsData: {
      totalCallsAttempted: 0,
      totalConnected: 0,
      callSources: {
        slash: {
          callsAttempted: 0,
          connectedPercentage: 0
        },
        ameyo: {
          callsAttempted: 0,
          connectedPercentage: 0
        },
        self: {
          callsAttempted: 0,
          connectedPercentage: 0
        }
      }
    }
  }
};

const TelePerformanceDashboardSlice = createSlice({
  name: 'telePerformanceDashboard',
  initialState,
  reducers: {
    setCycleData(state, action) {
      state.cycleOptions = action.payload;
    },
    setEmiCollectedData(state, action) {
      state.emiCollectedOverview = action.payload;
    },
    setPtpsOverviewMTD(state, action) {
      state.ptpOverview = action.payload;
    },
    setCallData(state, action) {
      state.callData = action.payload;
    }
  }
});

export const { setEmiCollectedData, setPtpsOverviewMTD, setCallData, setCycleData } =
  TelePerformanceDashboardSlice.actions;

export default TelePerformanceDashboardSlice.reducer;
